import React, { useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import makeStyles from '@material-ui/styles/makeStyles';


const useStyles = makeStyles((theme) => ({
    myAlert: {
        color: "#ffffff",
        backgroundColor: "rgba(36, 42, 51, 0.9)",
        "& .MuiAlert-icon": {
            color: "#ffffff" // Changes only the info icon color to white
        }
    },
    updateButton: {
        color: "#ffffff",
    },
    snackbar: {
        top: 100, // Default top padding for desktop
        [theme.breakpoints.down("md")]: {
            top: 80, // Extra space for mobile header bar
        },
        [theme.breakpoints.up("md")]: {
            top: 20, // Extra space for mobile header bar
        }
    }
}));

function NewReleaseAlert() {
    const classes = useStyles();
    const [newVersion, setNewVersion] = useState(false);

    useEffect(() => {
        fetch('/version.json', { cache: 'no-cache' })
          .then(res => res.json())
          .then(({ buildHash }) => {
            const previousHash = localStorage.getItem('appBuildHash');
            if (previousHash && previousHash !== buildHash) {
              setNewVersion(true); // show "Update available"
            }
            // localStorage.setItem('appBuildHash', buildHash);
          });
      }, []);

    const handleUpdate = () => {
       // Force update by clearing all caches and reloading the page
      fetch('/version.json', { cache: 'no-cache' })
        .then(res => res.json())
        .then(({ buildHash }) => {
            localStorage.setItem('appBuildHash', buildHash);
        });
        caches.keys().then((names) =>
            Promise.all(names.map((name) => caches.delete(name)))
        ).then(() => {
            window.location.reload();
        });
    };

    return (
        <Snackbar
            open={newVersion}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={6000}
            className={classes.snackbar}
        >
            <Alert
                className={classes.myAlert}
                severity="info"
                action={
                    <Button
                        className={classes.updateButton}
                        size="small"
                        onClick={handleUpdate}
                    >
                        Update
                    </Button>
                }
            >
                A new version is available! Click update to refresh.
            </Alert>
        </Snackbar>
    );
}

export default NewReleaseAlert;